<div class="download-version-dialog">
  <h2>Select submission version</h2>

  <mat-form-field class="select-field">
    <mat-label>Submission</mat-label>
    <mat-select [(value)]="selectedSubmissionCount">
      @for (option of options; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="actions">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="confirm()">
      Download
    </button>
  </div>
</div>
